import { useEffect, useState } from 'react';
import type { Membership } from '../../api/types.js';

const ROLE_LABELS: Record<Membership['role'], string> = {
  viewer: 'Lecture (viewer)',
  ap_clerk: 'Comptable AP (ap_clerk)',
  ap_approver: 'Validateur AP (ap_approver)',
  ap_admin: 'Admin AP (ap_admin)',
  group_admin: 'Admin groupe (group_admin)',
};

const ROLES: Membership['role'][] = [
  'viewer',
  'ap_clerk',
  'ap_approver',
  'ap_admin',
  'group_admin',
];

interface Props {
  member: Membership;
  memberLabel: string;
  busy: boolean;
  errorMessage: string | null;
  onSubmit: (role: Membership['role']) => void;
  onClose: () => void;
}

export function ChangeRoleModal({
  member,
  memberLabel,
  busy,
  errorMessage,
  onSubmit,
  onClose,
}: Props) {
  const [role, setRole] = useState<Membership['role']>(member.role);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="modal__backdrop"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      data-testid="change-role-modal"
    >
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="change-role-title">
        <header className="modal__head">
          <h2 id="change-role-title" className="display modal__title">
            Changer le rôle
          </h2>
          <button type="button" className="modal__close" onClick={onClose} aria-label="Fermer">
            ×
          </button>
        </header>

        <p className="muted" style={{ margin: '0 0 12px' }}>
          {memberLabel}
        </p>

        <label className="invoices__advanced-field" style={{ display: 'block' }}>
          <span className="eyebrow">Nouveau rôle</span>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value as Membership['role'])}
            data-testid="change-role-select"
          >
            {ROLES.map((r) => (
              <option key={r} value={r}>
                {ROLE_LABELS[r]}
              </option>
            ))}
          </select>
        </label>

        {errorMessage ? (
          <div
            className="invoices__error"
            role="alert"
            data-testid="change-role-error"
            style={{ marginTop: 10 }}
          >
            {errorMessage}
          </div>
        ) : null}

        <footer className="modal__foot">
          <button type="button" className="btn-ghost" onClick={onClose}>
            Annuler
          </button>
          <button
            type="button"
            className="btn-primary"
            disabled={busy || role === member.role}
            onClick={() => onSubmit(role)}
            data-testid="change-role-submit"
          >
            {busy ? 'Enregistrement…' : 'Enregistrer'}
          </button>
        </footer>
      </div>
    </div>
  );
}
